module.exports = __webpack_public_path__ + "static/media/sangram.ee1d7806.png";